<template>
  <button @mouseenter="setTooltip()" @mouseleave="setTooltip()" :class="{active: (shape.textDecoration === 'underline')}" class="btn btn-icon waves-effect btn-default waves-light" @click="fontUnderline()"> <i class="icon-underline"></i> </button>
</template>

<script>
export default {
    name: 'underline',
    props: {
        shape: {
            default: {
                locked: false
            }
        }
    },
    methods: {
        fontUnderline: function () {
            this.$emit('underline')
        },
        setTooltip: function () {
            this.$emit('tooltip')
        }
    }
}
</script>



// WEBPACK FOOTER //
// underline.vue?2a8294cc